import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'

import './index.scss'

import App from './containers/App'
import ErrorPage from './containers/ErrorPage'
import amplifyConfig from './amplify_config'

import * as serviceWorker from './serviceWorker'

import ReactGA from 'react-ga'
import Amplify from 'aws-amplify'
import config from './config'
import * as Sentry from '@sentry/browser'
import { ErrorBoundary } from '@sentry/react'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faCheck,
  faEllipsisH,
  faCloudUploadAlt,
  faExclamationTriangle
} from '@fortawesome/free-solid-svg-icons'

library.add(faCheck, faEllipsisH, faCloudUploadAlt, faExclamationTriangle)

Sentry.init({
  dsn: config.SENTRY_DSN,
  environment: config.stage,
})

Amplify.configure(amplifyConfig)

if (config.FB_APP_ID) {
  (window as any).fbAsyncInit = function() {
    FB.init({
      appId            : config.FB_APP_ID!,
      autoLogAppEvents : true,
      xfbml            : true,
      version          : 'v3.2'
    })
  }
}

if (config.GA_TRACKING_ID) {
  ReactGA.initialize(config.GA_TRACKING_ID)
} else {
  ReactGA.initialize('test', { testMode: true });
  (window as any).ReactGA = ReactGA
}
ReactGA.pageview(window.location.pathname + window.location.search)

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary fallback={ErrorPage} showDialog>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
